import React from 'react';

import { Button, Modal } from '@unimed-fesp/components';

import { ModalContent, ModalContentWrapper } from '../../molecules/Modal';

import theme from '../../../styles/theme';

import { Container, ContentText, TextSucesso } from './styles';

function ModalFiltrosAplicados({ modalData, filtros, closeModal }) {
  const filtrosAplicado = filtros.find(
    (filtro) => filtro.taskId === modalData.taskId
  );

  function mostrarFiltrosIguaisAosParametros() {
    if (!filtrosAplicado) {
      return;
    }

    const descricaoFiltros = {
      1: 'Beneficiário Ativo',
      2: 'Beneficiário Excluído',
      3: 'Beneficiário Inativo',
    };

    const filtro = JSON.parse(filtrosAplicado.parametros);
    const filtroFormatado = {
      tipoConsulta: descricaoFiltros[filtro.TipoConsultaBeneficiario] || false,
      contratante: filtro.CodigoContratanteLogada || false,
      grupoContratante:
        filtro.FiltroContratante !== filtro.CodigoContratanteLogada.toString()
          ? filtro.FiltroContratante
          : false,
      modalidade: filtro.Modalidade || false,
      termo: filtro.Termo || false,
      layout: filtro.LeiauteVersao1 ? 'Layout 1' : 'Layout 2',
      extensão: filtro.ExportarXlsx ? 'xlsx' : 'txt',
      dataPeríodoDeReferênciaDe: filtro.DataReferenciaInicial
        ? new Date(filtro.DataReferenciaInicial)
        : false,
      dataPeríodoDeReferênciaAte: filtro.DataReferenciaFinal
        ? new Date(filtro.DataReferenciaFinal)
        : false,
      exclusãoProgramada: filtro.BeneficiarioComDataExclusaoProgramada
        ? 'Sim'
        : false,
    };

    return Object.entries(filtroFormatado).map(([chave, valor]) => {
      const valorParaRenderizar =
        valor instanceof Date ? valor.toLocaleDateString() : valor;

      if (valor) {
        return (
          <ContentText key={chave}>
            {formatCamelCase(chave)}: {valorParaRenderizar}
          </ContentText>
        );
      }
    });
  }

  function formatCamelCase(str) {
    const words = str.split(/(?=[A-Z])/);
    const result = words
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');

    return result;
  }

  return (
    <Modal
      isOpen={modalData.isOpen}
      onClick={closeModal}
      height={360}
      width={460}
      footer={<ModalFooter onClick={closeModal} />}
      header={<TextSucesso text="Filtros Aplicados" />}
    >
      <ModalContentWrapper>
        <ModalContent>
          <Container>{mostrarFiltrosIguaisAosParametros()}</Container>
        </ModalContent>
      </ModalContentWrapper>
    </Modal>
  );
}

const ModalFooter = ({ onClick }) => {
  return (
    <Button
      tipo="secondary"
      onClick={onClick}
      color={theme.greenDefault}
      marginRight={10}
      width={100}
      alignCenter
      justifyCenter
    >
      Sair
    </Button>
  );
};

export default ModalFiltrosAplicados;
